import { getTvObject, tv } from '@costar-ui/cosmos';

var baseTV = getTvObject({
  base: ['csg-tw-switch', 'relative', 'flex']
});
var baseStyles = tv(baseTV);

export { baseStyles, baseTV };
//# sourceMappingURL=switch-base.styles.esm.js.map
